import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';

const _logLevel = {
  trace: 'trace',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error',
  fatal: 'fatal'
};

const _logLevelIndices = [
  _logLevel.trace,
  _logLevel.debug,
  _logLevel.info,
  _logLevel.warn,
  _logLevel.error,
  _logLevel.fatal
];

const Content: {
  time: Date | null,
  logLevel: string,
  type: string,
  message: string
} = {
  time: null,
  logLevel: _logLevel.info,
  type: '',
  message: ''
};

class LogEntry extends Immutable.Record(Content) {
  static createFromAction (action: ActionType): LogEntry {
    // remove the logLevel and actionType from the action to log
    // because they are already included in the LogEntry itself
    let actionToLog: Partial<ActionType> = Object.assign({}, action);
    delete actionToLog.logLevel;
    delete actionToLog.actionType;

    if (actionToLog.previews != null) {
      // only log the keys of the previews map, not the values (=JPGs)!
      actionToLog.previews = actionToLog.previews.keySeq();
    }
    return new LogEntry({
      time: new Date(),
      logLevel: action.logLevel,
      type: action.actionType,
      message: JSON.stringify(actionToLog)
    });
  }

  static get logLevel () {
    return _logLevel;
  }

  static getLogLevelIndex (logLevel: string): number {
    return _logLevelIndices.indexOf(logLevel);
  }
}

export default LogEntry;
